import { FleetSignalScreen } from "@src/features/patriot-tools";

export default FleetSignalScreen;
